import React from 'react'
import { StepsProps, StepsUi } from '../Steps/Steps'

export type HStepsProps = Omit<StepsProps, 'direction'>
export const HSteps = (props: HStepsProps) => (
  <StepsUi {...props} direction='horizontal' className={'HSteps'} />
)
